// @flow

import { Map } from 'immutable';
import {
  RESOURCES_DETAILS,
  LOAD_RESOURCES_DETAILS_SUCCESS,
  LOAD_RESOURCES_DETAILS_FAIL,
  ERROR,
  CLEAR_ERROR,
} from './../types/resource';

import {
  SIGN_OUT,
} from './../types/auth';

import type { ResourceAction } from './../actions/resource';

const INITIAL_MAP = Map({
  [RESOURCES_DETAILS]: [],
  [ERROR]: "",
});

const resourceReducer = (state: Map<string, any> = INITIAL_MAP, action: ResourceAction) => {
  switch (action.type) {
    case LOAD_RESOURCES_DETAILS_SUCCESS:
      if (action[RESOURCES_DETAILS].length === 0)
        return state
          .set(RESOURCES_DETAILS, action[RESOURCES_DETAILS])
      return state
        .set(RESOURCES_DETAILS, action[RESOURCES_DETAILS])

    case LOAD_RESOURCES_DETAILS_FAIL:
      return state
        .set(RESOURCES_DETAILS, null)
        .set(ERROR, 'Error occured while loading resource details');

    case CLEAR_ERROR:
      return state.set(ERROR, '');

    case SIGN_OUT:
      return INITIAL_MAP;

    default:
      return state;
  }
};

export default resourceReducer;



// WEBPACK FOOTER //
// ./src/reducers/resource.jsx